



















































































import Component from "vue-class-component";
import BasicComponent from "@/global/BasicComponent";
import DiscountBanner from "@/components/DiscountBanner.vue";
import {ProductDto} from "@swagger";

@Component({
  components: {DiscountBanner}
})
export default class Products extends BasicComponent {

  created() {

  }

  mounted() {
    //if (this.$store.getters.step === "3") this.trackPage("Produkte");
  }

  get products() {
    return this.$store.getters.products;
  }

  formatProductPrice(product: ProductDto): string {
    return `${product.detailedConfigurationSurcharge > 0 ? 'Ab ' : ''}${this.formatPrice(product.price)}`;
  }

  getImageUrl(image) {
    var images = require.context('@/assets/', false, /\.jpg$/);
    return images('./' + image);
  }

  getDiscount(product) {
    let instead = product.setPriceInsteadOf;
    if (!instead) instead = product.price;
    return product.price / instead - 1;
  }

  hasDiscount(product) {
    return this.getDiscount(product) <= -0.01; // At least 1%
  }

  formatDiscount(discount) {
    return `${Math.round(discount * 100)}%`
  }

}
